<!-- FIX: Use a single-column flex layout for the main content -->
<form [formGroup]="stopForm" class="flex flex-col gap-6">
  <!-- The entire form is now a single column of cards -->
  <app-card class="overflow-hidden">
    <!-- FIX: Integrate the header directly into the first card for a cohesive look -->
    <div class="p-4 bg-muted/50 border-b border-border">
      <div
        class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
      >
        <app-heading level="h2">Stop {{ stopNumber() }}</app-heading>
        <app-button-group formControlName="stopType" [options]="stopTypes" />
      </div>
    </div>

    <!-- Card Content -->
    <div class="flex flex-col gap-4 py-4">
      <app-form-field label="Company Name">
        <app-input
          formControlName="companyName"
          placeholder="Enter company name"
        ></app-input>
      </app-form-field>
      <app-address-form formControlName="address"></app-address-form>
      <app-contact-input formControlName="contactInfo"></app-contact-input>
      <app-form-field label="Hours of Operation">
        <app-input
          formControlName="operatingHours"
          placeholder="e.g., M-F 9am - 5pm"
        ></app-input>
      </app-form-field>
    </div>
  </app-card>

  <app-card headerText="Appointment" icon="clock">
    <app-appointment-control
      formControlName="appointment"
      orientation="vertical"
    ></app-appointment-control>
  </app-card>

  <app-card headerText="References" icon="file-text">
    <app-form-field label="Stop-Level Reference Numbers">
      <app-key-value-array-input
        formControlName="referenceNumbers"
        addButtonLabel="Add Reference"
        [keys]="referenceTypes"
      ></app-key-value-array-input>
    </app-form-field>
  </app-card>

  <app-card headerText="Product" icon="package">
    <div class="flex flex-col gap-4">
      <app-form-field label="Weight (lbs)">
        <app-number-input
          formControlName="weight"
          placeholder="0"
          [showGrouping]="true"
          suffixText="lbs"
        ></app-number-input>
      </app-form-field>
      <app-form-field label="Stop-Level Item Counts">
        <app-key-value-array-input
          formControlName="itemCounts"
          addButtonLabel="Add Item Count"
          [keys]="itemTypes"
        ></app-key-value-array-input>
      </app-form-field>
    </div>
  </app-card>

  <app-card headerText="Instructions & Notes" icon="notebook-pen" class="">
    <div class="flex flex-col gap-4">
      <app-form-field label="Driver Instructions" class="mt-0">
        <app-textarea
          formControlName="instructions"
          placeholder="Add instructions..."
          [rows]="4"
        ></app-textarea>
      </app-form-field>
      <app-form-field label="Other Notes" class="mt-0">
        <app-textarea
          formControlName="notes"
          placeholder="Add notes..."
          [rows]="4"
        ></app-textarea>
      </app-form-field>
    </div>
  </app-card>
</form>
